import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { PoNumbersModel } from './po-number.model';


export class PoNumbersResponseModel extends GlobalResponseObject {
    data?: PoNumbersModel[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: PoNumbersModel[]){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

